module.exports = __webpack_public_path__ + "img/employees.938f2f1b.png";